/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforguestsnoneyet4Inputs */

const en_goodforguestsnoneyet4 = /** @type {(inputs: Goodforguestsnoneyet4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough votes yet.`)
};

const de_goodforguestsnoneyet4 = /** @type {(inputs: Goodforguestsnoneyet4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch zu wenige Stimmen.`)
};

/**
* | output |
* | --- |
* | "Not enough votes yet." |
*
* @param {Goodforguestsnoneyet4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforguestsnoneyet4 = /** @type {((inputs?: Goodforguestsnoneyet4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforguestsnoneyet4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforguestsnoneyet4(inputs)
	return de_goodforguestsnoneyet4(inputs)
});
export { goodforguestsnoneyet4 as "goodForGuestsNoneYet" }